export const CsErrorText = {
    errDataValidation: { 'th' : 'ข้อมูลที่ได้รับไม่ถูกต้อง','en' : ''}
}